import { useMemo } from 'react';
import { EqualityFn } from 'react-redux';
import { useAppDispatch, useAppSelector } from '@STORE/index';

import { 
    chapterIntroductionTextModalSlice, 
    ChapterIntroductionTextModalDispatchParams, 
    ChapterIntroductionTextModalState,
} from '@REDUCERS';

function createChapterIntroductionTextModalHook() {
    return function useChapterIntroductionTextModal(equalityFn?: EqualityFn<ChapterIntroductionTextModalState>) {
        const state = useAppSelector((store) => store.chapterIntroductionTextModal, equalityFn);

        const dispatch = useAppDispatch();

        const actions = useMemo(() => ({
            open: (params: ChapterIntroductionTextModalDispatchParams) => dispatch(chapterIntroductionTextModalSlice.actions.open(params)),
            close: () => dispatch(chapterIntroductionTextModalSlice.actions.close()),
        }), [dispatch]);

        return {
            state,
            actions,
        };
    };
}

export default createChapterIntroductionTextModalHook(); 